export default __webpack_public_path__ + "static/media/hamburger_icons-02.b87c23ce.png";